import React from "react";

const AdImageCreate = () => {
  return <div>AdImageCreate</div>;
};

export default AdImageCreate;
